import { Typography, Button, Box } from '@mui/material'

interface propTypes {
  icon: any
  href: string
  title: string
  text: string
}
const ContactCard: React.FC<propTypes> = (props) => {
  const { icon, href, title, text } = props
  return (
    <Button
      component="a"
      href={href}
      target="_blank"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#fff',
        px: { xs: 2, md: 3 },
        py: { xs: 3, md: 5 },
        mb: { xs: 2, md: 0 },
        fontSize: 'large',
        width: { xs: '70%', sm: '30%', md: '25%' },
        transition: 'all 0.2s',
      }}
    >
      <Box
        sx={{
          border: '1px solid',
          display: 'flex',
          p: 2,
          borderRadius: '50%',
          backgroundColor: '#fff',
          '> svg': {
            fontSize: '2.1875rem',
          },
        }}
      >
        {icon}
      </Box>
      <Typography sx={{ mt: 2, mb: 3 }} variant="h5">
        {title}
      </Typography>
      <Typography
        variant="h6"
        sx={{ textAlign: 'center', wordBreak: 'break-word' }}
      >
        {text}
      </Typography>
    </Button>
  )
}

export default ContactCard
